import {
  Component,
  OnInit,
  ViewChild,
  Inject,
  TemplateRef
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../../../providers/api.service';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AbstractControl, ValidationErrors } from '@angular/forms';


class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
  TotalFiles: number;
}

@Component({
  selector: 'app-update-salary-rights',
  templateUrl: './update-salary-rights.component.html',
  styleUrls: ['./update-salary-rights.component.css']
})
export class UpdateSalaryRightsComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false }) datatableElement: DataTableDirective;
  @ViewChild('addSalaryRight', { static: false }) addSalaryRight!: TemplateRef<any>;
  dtOptions: DataTables.Settings = {};
  AddSalaryEmpRightForm: FormGroup;
  dataAr: any = [];
  MonthArray:any = [];
  dialogRefAddEmpRight: MatDialogRef<any>; 
  isSubmitted:boolean = false;
  FinancialYear:any= [];
  SelectedYear:any;
  employee_ar : any = [];
  dropdownSettingMultipleSelect: {};
  dropdownSettingsingleselect: any = {};
  startTime: Date;
  endTime: Date;
  minDate: Date;
  maxDate: Date;

  constructor(
    public dialogRef: MatDialogRef<UpdateSalaryRightsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public api: ApiService,
    private http: HttpClient,
    public formBuilder: FormBuilder
  ) {

    this.employee_ar = this.data.Emps_Ar;
    this.MonthArray = this.data.MonthArray;
    this.FinancialYear = this.data.FinancialYear;
    this.SelectedYear = this.data.SelectedYear;

    this.dropdownSettingMultipleSelect = {
      singleSelection: false,
      idField: "Id",
      textField: "Name",
      itemsShowLimit: 1,
      enableCheckAll: false,
      allowSearchFilter: true,
    };

    this.dropdownSettingsingleselect = {
      singleSelection: true,
      idField: "Id",
      textField: "Name",
      itemsShowLimit: 2,
      enableCheckAll: false,
      allowSearchFilter: false,
    };
  }

  ngOnInit(): void {
    this.AddSalaryEmpRightForm = this.formBuilder.group({
      EmpIds: ["", [Validators.required]],
      Date: ["", [Validators.required]],
      Start_Time: ["", [Validators.required]],
      End_Time: ["", [Validators.required]],
    });

    this.loadSalaryRights();
  }

  get formControls() { return this.AddSalaryEmpRightForm.controls; }

  loadSalaryRights() {
    this.api.IsLoading();
    const that = this;
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      serverSide: true,
      processing: true,
      // dom: "ilpftripl",
      ajax: (dataTablesParameters: any, callback) => {
        that.http
          .post<DataTablesResponse>(
          `${environment.apiUrlBmsBase}/../v1/goal-management-system/CrudFunctions/GetUpdateSalaryRights?User_Id==${this.api.GetUserData("Id")}&User_Type=${this.api.GetUserType()}&User_Code=${this.api.GetUserData("Code")}`,
          dataTablesParameters,
          this.api.getHeader(environment.apiUrlBmsBase)
        )
        .subscribe((res:any) => {
          let resp = JSON.parse(this.api.decryptText(res.response));
          if (resp.data) {
            that.dataAr = resp.data;
          }
          this.api.HideLoading();
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: [],
          });
        });
      },
    };
  }


  reloadTable(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      const pageInfo = dtInstance.page.info().page;
      dtInstance.page(pageInfo).draw(false);
    });
  }

  closeModel(): void {
    this.dialogRef.close({ Status: 'Model Close' });
  }

  addSalaryRights(){
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    this.minDate = today;    
    this.maxDate = endOfMonth;
    
    const startTime = new Date(new Date().getTime() + 5 * 60000);
    const endTime = new Date(startTime.getTime() + 60 * 60000);
    this.startTime = startTime;
    this.endTime = endTime;

    // Reset the form with fresh default values
    this.AddSalaryEmpRightForm.setValue({
      EmpIds: "",
      Date: "",
      Start_Time: startTime,
      End_Time: endTime
    });

    this.dialogRefAddEmpRight = this.dialog.open(this.addSalaryRight, {
      width: '30%',
      height: '70%',
      disableClose: true, 
    });
    this.dialogRefAddEmpRight.afterClosed().subscribe(result => {
      console.log('Dialog closed with result:', result);
    });
  }

  closeAddEmpRightModel(): void {
    if (this.dialogRefAddEmpRight) {
      this.AddSalaryEmpRightForm.reset();
      this.dialogRefAddEmpRight.close();
      this.isSubmitted = false;
      this.reloadTable();
    }
  }

  UpdateFinalSalaryRight() {
    this.isSubmitted = true;
    if (this.AddSalaryEmpRightForm.invalid) {
      return;
    } 
    var fields = this.AddSalaryEmpRightForm.value;
    const formData = new FormData();
    formData.append('User_Id', this.api.GetUserData('Id'));
    formData.append('User_Code', this.api.GetUserData('Code'));
    formData.append('EmpIds', JSON.stringify(fields['EmpIds']));
    formData.append('Date',  fields['Date']);
    formData.append('Start_Time',  fields['Start_Time']);
    formData.append('End_Time', fields['End_Time']);
    formData.append('Portal', 'CRM');

    this.api.IsLoading();
    this.api.HttpPostTypeBms('goal-management-system/CrudFunctions/UpdateSalaryRights', formData).then((result:any) => {
      this.api.HideLoading();
      if (result['Status'] == true) {
        this.api.Toast('Success', result['Message']);
        this.closeAddEmpRightModel();
      } else {
        this.api.Toast('Error', result['Message']);
      }
    }, (err) => {
      this.api.HideLoading();
      this.api.Toast('Warning', 'Network Error, Please try again ! ');
    });
  }

  deleteSalaryRights(Id: number) {
    // Show confirmation popup before deletion
    if (!confirm("Are you sure you want to delete this salary right?")) {
      return; // If user cancels, do nothing
    }

    const formData = new FormData();
    formData.append('User_Id', this.api.GetUserData('Id'));
    formData.append('User_Code', this.api.GetUserData('Code'));
    formData.append('Id', Id.toString());

    this.api.IsLoading();
    this.api.HttpPostTypeBms('goal-management-system/CrudFunctions/DeleteSalaryRights', formData).then((result: any) => {
      this.api.HideLoading();
      if (result['Status'] === true) {
        this.api.Toast('Success', result['Message']);
        this.reloadTable();
      } else {
        this.api.Toast('Error', result['Message']);
      }
    }, (err) => {
      this.api.HideLoading();
      this.api.Toast('Warning', 'Network Error, Please try again!');
    });
  }

  

}
